module.exports = __webpack_public_path__ + "static/media/log_reg.433b958a.svg";